import request from '../../../api/request';
import { Module} from 'vuex'
import {RootState} from '../../interface'

const renewModule:Module<any,RootState>={
  state: {
  },
  actions: {
    renewSubmit : ({commit},data) => {
      return new Promise((resolve, reject)=>{
          request.post('/api/v1/app/advance-renew/submit',data).then(res =>{
              resolve(res)
          })
      })
    },
  }

}

export default renewModule

  